import React from 'react';
import Header from '../../components/header';
import PrivacyPolicyBody from './body';
import Footer from '../../components/footer';

function PrivacyPolicy(props) {
    document.title = `Yebokenny Privacy Policy`;
    return (
        <div>
           <Header></Header> 
           <PrivacyPolicyBody></PrivacyPolicyBody>
           <Footer></Footer>
        </div>
    );
}

export default PrivacyPolicy;